enum System {
    WEB = 'WEB',
    FARM = 'FARM'
}

export { System };
